/** Dependencies */
import angular from 'angular';
import csmPaymentsData from './csm.payments.data';
import csmPaymentsDom from './csm.payments.dom';
import csmPaymentsServices from './csm.payments.services';


/*******************************************************************************
 * @ngdoc  overview
 * @module csm.payments
 * @description
 * Payments API client side components.
 *******************************************************************************/
angular
  .module('csm.payments', [
    csmPaymentsData,
    csmPaymentsDom,
    csmPaymentsServices
  ])

/*******************************************************************************
* AssetFiles
/**
* @ngdoc  constant
* @name   csm.payments:constant.Assets
* @description
* Map of asset files loaded by Javascript that may not be part of the production 
* file bundle. This includes CSS files that must be sent to a card processor for 
* use in styling IFRAME input fields. It maps the file name to the URL relative
* to the script file consuming it.
*
* See `gulpfile.js` to see how the build process creates a script that modifies 
* this constant to refer to production file paths.
*******************************************************************************/
  .constant('AssetFiles', {
    'openedgePayfields.iframe.css': 'openedgePayfields.iframe.css',
    'pacePaymentFrame.iframe.css': 'pacePaymentFrame.iframe.css'
  });
